var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kickstarter-graph cutout",style:({
    width: '100%'
  })},[_c('div',{attrs:{"id":"kickstarter"}}),_c('div',{staticStyle:{"display":"none"},attrs:{"id":"kickstarter-hidden"}})])}
var staticRenderFns = []

export { render, staticRenderFns }